import React from 'react';
import cih from '../images/cih.png'
import aw from '../images/aw.png'
import bmce from '../images/bmce.png'
import bmci from '../images/bmci.png'
import sgmb from '../images/sgmb.png'
import bp from '../images/bp.png'
import cdm from '../images/cdg.png'
import cam from '../images/cpb.png'
import other from '../images/other.png'

const bankOptions = [
  { value: 'CIH', label: 'CIH', icon: cih },
  { value: 'Attijariwafa Bank', label: 'Attijariwafa Bank', icon: aw },
  { value: 'BMCE', label: 'BMCE', icon: bmce },
  { value: 'BMCI', label: 'BMCI', icon: bmci },
  { value: 'Société Générale Maroc', label: 'Société Générale Maroc', icon: sgmb },
  { value: 'Banque Populaire', label: 'Banque Populaire', icon: bp },
  { value: 'Crédit du Maroc', label: 'Crédit du Maroc', icon: cdm },
  { value: 'Crédit Agricole du Maroc', label: 'Crédit Agricole du Maroc', icon: cam },
  { value: 'Autre', label: 'Autre', icon: other },
]

export default function SallerBank({ bank }) {
  // Find the bank in the options
  const bankData = bankOptions.find(option => option.value === bank);
  
  if (!bankData) {
    return <div>{bank}</div>; // Return just the bank name if not found
  }

  return (
    <div className="flex items-center font-semibold">
      <img 
        src={bankData.icon} 
        alt={bankData.label} 
        width={16}
        height={16}
        className="w-5 h-5 mr-1"
      />
      {bankData.label}
    </div>
  );
}